import React from "react"
import PropTypes from "prop-types"

const ErrorMessage = ({text}) => {
  return (
    <div className="clock-in-error">
      <img src="/images/clock-in/error-sign.png"/>
      <span>Error: </span>
      {text}
    </div>
  )
}

ErrorMessage.propTypes = {
  text: PropTypes.string
}

export default ErrorMessage
